import {
  DYNAMIC_COMPONENT_INIT,
  DYNAMIC_COMPONENT_INIT_WITH_STATE,
  DYNAMIC_COMPONENT_NAV_CHILD,
  DYNAMIC_COMPONENT_NAV_PARENT,
  DYNAMIC_COMPONENT_NAV_SIBLING_NEXT,
  DYNAMIC_COMPONENT_NAV_SIBLING_PREV,
  DYNAMIC_COMPONENT_NAV_NEXT,
  DYNAMIC_COMPONENT_SAVE_DATA,
  DYNAMIC_COMPONENT_SAVE_DATA_ERROR,
  DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION,
  DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES,
  DYNAMIC_COMPONENT_CLEAN_DATA,
  SAVE_ENTITY_DATA,
  CLEAR_ENTITY_DATA,
  TRIGGER_DIRTY_MAP,
  VALIDATE_CONFIG_RULES_RUNNING,
  VALIDATE_CONFIG_RULES_FINISHED,
  SET_VALIDATION_CONFIGURATION,
  SAVE_SECTION_STATUSES,
  UPDATE_VERSION,
  SAVING_NETWORK_ERROR,
  CLEAR_DYNAMIC_COMPONENT,
  QUEUE_SAVE,
  DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE,
} from 'common/types';

export default {
  init: (config, data, serviceCall) => ({
    type: DYNAMIC_COMPONENT_INIT,
    config,
    data,
    serviceCall,
  }),
  initWithState: (initState) => ({
    type: DYNAMIC_COMPONENT_INIT_WITH_STATE,
    initState,
  }),
  navChild: (index) => ({
    type: DYNAMIC_COMPONENT_NAV_CHILD,
    index,
  }),
  navParent: () => ({
    type: DYNAMIC_COMPONENT_NAV_PARENT,
  }),
  navSiblingNext: () => ({
    type: DYNAMIC_COMPONENT_NAV_SIBLING_NEXT,
  }),
  navSiblingPrev: () => ({
    type: DYNAMIC_COMPONENT_NAV_SIBLING_PREV,
  }),
  navToSpecificLocation: (specificLocation) => ({
    type: DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION,
    specificLocation,
  }),
  navNext: () => ({
    type: DYNAMIC_COMPONENT_NAV_NEXT,
  }),
  saveData: (dataPath, componentData) => ({
    type: DYNAMIC_COMPONENT_SAVE_DATA,
    dataPath,
    componentData,
  }),
  saveDataErrors: (dataPath, errors) => ({
    type: DYNAMIC_COMPONENT_SAVE_DATA_ERROR,
    dataPath,
    errors,
  }),
  saveDataBasedTitles: (dataBasedTitles) => ({
    type: DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES,
    dataBasedTitles,
  }),
  updateVersion: (dataPath, data, modifiedBy, isConcurrencyModalActive, modifyDate) => ({
    type: UPDATE_VERSION,
    dataPath,
    data,
    modifiedBy,
    isConcurrencyModalActive,
    modifyDate,
  }),
  cleanData: () => ({
    type: DYNAMIC_COMPONENT_CLEAN_DATA,
  }),
  // dataPath to save the data to, entityType for making a save api call after update
  saveEntityData: (
    dataPath,
    entityType,
    data,
    fieldPath,
    saveMany,
    extraProps,
    entityTypeReduxPath,
    patchRequest
  ) => ({
    type: SAVE_ENTITY_DATA,
    dataPath,
    entityType,
    data,
    fieldPath,
    saveMany,
    extraProps,
    entityTypeReduxPath,
    patchRequest,
  }),
  triggerDirtyMap: (fieldPath) => ({
    type: TRIGGER_DIRTY_MAP,
    fieldPath,
  }),
  queueSave: (entityType) => ({
    type: QUEUE_SAVE,
    entityType,
  }),
  clearEntityData: (dataPath, entityType, validationId) => ({
    type: CLEAR_ENTITY_DATA,
    dataPath,
    entityType,
    validationId,
  }),
  // good for a single session only, doesn't save to dynamo
  saveEntitySessionData: (dataPath, data, fieldPath) => ({
    type: SAVE_ENTITY_DATA,
    dataPath,
    data,
    fieldPath,
  }),
  validateConfigRules: () => ({
    type: VALIDATE_CONFIG_RULES_RUNNING,
  }),
  setValidationsWith: (rules) => ({
    type: SET_VALIDATION_CONFIGURATION,
    rules,
  }),
  saveValidationResults: (validationResults, allValid) => ({
    type: VALIDATE_CONFIG_RULES_FINISHED,
    results: validationResults,
    allValid,
  }),
  saveSectionStatuses: (sectionStatuses) => ({
    type: SAVE_SECTION_STATUSES,
    sectionStatuses: sectionStatuses,
  }),
  handleSaveError: (error) => ({
    type: SAVING_NETWORK_ERROR,
    error: error,
  }),
  clearDynamicComponent: () => ({
    type: CLEAR_DYNAMIC_COMPONENT,
  }),
  setTotalHoldingAmountExceedsFedShare: (dataPath, componentData) => ({
    type: DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE,
    dataPath,
    componentData,
  }),
};
